import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import {
  BUCKET_QUERY_PARAM_KEY,
  NAVIGATION_QUERY_PARAM_KEY,
  OVERLAY_QUERY_PARAM_KEY,
  PAGE_QUERY_PARAM_KEY,
  POSITION_ID_QUERY_PARAM_KEY,
  SEARCH_QUERY_PARAM_KEY,
  SELECTED_JOB_APPLICATION_PARAM_KEY,
  JOB_ID_QUERY_PARAM_KEY,
  REFERRER_QUERY_PARAM_KEY,
  CANDIDATE_PROFILE_DRAWER_TAB_PARAM_KEY,
} from '../../pages/CandidateManagementPage/queryParams';
import { getBucketFromQuery } from '../../pages/CandidateManagementPage/utils/BucketQueryParam';
import { getTabFromQuery } from '../../pages/CandidateManagementPage/utils/TabQueryParam';
import type { QueryParams } from './types';
import SetQueryParams from './SetQueryParams';
import type { OVERLAY_MODAL } from 'src/constants/modals';

export const queryParamConfigMap = {
  [POSITION_ID_QUERY_PARAM_KEY]: withDefault(NumberParam, undefined),
  [BUCKET_QUERY_PARAM_KEY]: withDefault(StringParam, undefined),
  [PAGE_QUERY_PARAM_KEY]: withDefault(NumberParam, undefined),
  [SELECTED_JOB_APPLICATION_PARAM_KEY]: withDefault(StringParam, undefined),
  [SEARCH_QUERY_PARAM_KEY]: withDefault(StringParam, undefined),
  [NAVIGATION_QUERY_PARAM_KEY]: withDefault(StringParam, undefined),
  [OVERLAY_QUERY_PARAM_KEY]: withDefault(StringParam, undefined),
  [JOB_ID_QUERY_PARAM_KEY]: withDefault(NumberParam, undefined),
  [REFERRER_QUERY_PARAM_KEY]: withDefault(StringParam, undefined),
  [CANDIDATE_PROFILE_DRAWER_TAB_PARAM_KEY]: withDefault(StringParam, undefined),
};

const useQueryParamsStore = (): [QueryParams, SetQueryParams] => {
  const [query, setQuery] = useQueryParams(queryParamConfigMap);

  const {
    [POSITION_ID_QUERY_PARAM_KEY]: positionId,
    [BUCKET_QUERY_PARAM_KEY]: bucketQueryString,
    [PAGE_QUERY_PARAM_KEY]: page,
    [SELECTED_JOB_APPLICATION_PARAM_KEY]: selectedProspectId,
    [SEARCH_QUERY_PARAM_KEY]: search,
    [OVERLAY_QUERY_PARAM_KEY]: overlay,
    [JOB_ID_QUERY_PARAM_KEY]: jobId,
    [REFERRER_QUERY_PARAM_KEY]: referrer,
    [CANDIDATE_PROFILE_DRAWER_TAB_PARAM_KEY]: tabQueryString,
  } = query;
  const bucket = getBucketFromQuery(bucketQueryString);
  const tab = getTabFromQuery(tabQueryString);

  return [
    {
      positionId,
      bucket,
      selectedProspectId,
      search,
      overlay: overlay as OVERLAY_MODAL,
      page: page || 1,
      jobId,
      referrer,
      tab,
    },
    new SetQueryParams(setQuery),
  ];
};

export default useQueryParamsStore;
